import React from 'react'
import { navigate } from '@reach/router'
import { useTranslation } from 'react-i18next'

import { Container, Grid, Typography } from '@material-ui/core'

import { Heading } from '../../components/Text'
import { WhiteButton } from '../../components/Button/WhiteButton'
import { GradientButton } from '../../components/Button/GradientButton'

import { useStyles } from './styles'
import keycloak, { loginWithLocale } from '../../keycloak'
import { useStoreState } from '../../store/store.hooks'
import * as Sentry from '@sentry/browser'

export const Login = () => {
  const { t, i18n } = useTranslation('login')
  const classes = useStyles()
  // keycloak.login needs the adapter, which exists from init START
  // (keycloak.didInitialize), not init completion — so the button enables on
  // whichever re-render comes first. The store flag (set on onReady,
  // onInitError, and by the watchdog — NOT useKeycloak().initialized, which
  // never turns true on onInitError) guarantees it can't stay dead.
  const keycloakInitDone = useStoreState((state) => state.auth.keycloakInitDone)
  const keycloakReady = keycloakInitDone || keycloak.didInitialize

  return (
    <Container className={classes.login} component="main" maxWidth={false}>
      <Grid className={classes.container}>
        <Heading>{t<string>('heading')}</Heading>
        <Typography className={classes.subHeading}>
          {t<string>('subHeading')}
        </Typography>
        <Container maxWidth="xs" className={classes.bodyContainer}>
          <GradientButton
            className={classes.emailLoginButton}
            disabled={!keycloakReady}
            onClick={() =>
              // Return to /login, NOT the origin: "/" self-redirects while
              // the OAuth callback fragment is still unparsed, destroying
              // the authorization code. /login is stable for anonymous
              // users, and once the token lands the authenticated router's
              // default RedirectHandler takes over.
              // The Keycloak login page opens in the language the user started
              // from (kc_locale), instead of the realm default.
              loginWithLocale(i18n.language, {
                redirectUri: `${window.location.origin}/login`,
              }).catch((error: unknown) => Sentry.captureException(error))
            }
          >
            {t<string>('emailLoginButton')}
          </GradientButton>
          <WhiteButton
            className={classes.registrationButton}
            onClick={() => navigate('/registration')}
          >
            {t<string>('registrationButton')}
          </WhiteButton>
        </Container>
        <div className={classes.bottomRegistrationBox}>
          <Typography className={classes.registrationBoxText}>
            {t<string>('doctorRegistration')}
          </Typography>
          <GradientButton
            className={classes.registrationBoxButton}
            onClick={() =>
              window.open('https://dokiapp.hu/#orvosoknak', '_blank')
            }
          >
            {t<string>('doctorButton')}
          </GradientButton>
        </div>
      </Grid>
    </Container>
  )
}
